import React from 'react'
import Page from 'shared/components/Page'
import Title from 'shared/components/Title'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { connect } from 'react-redux'

import CheckEmailPresentation from 'components/ResetPassword/CheckEmail'

class CheckEmail extends React.Component {
  static propTypes = {
    email: PropTypes.string,
    history: PropTypes.object,
  }

  componentDidMount() {
    if (_.isEmpty(this.props.email)) {
      this.props.history.push(`/404`)
    }
  }

  render() {
    return (
      <Page>
        <Title title="Check your email" />
        <CheckEmailPresentation email={this.props.email} />
      </Page>
    )
  }
}

const mapState = (state) => ({
  email: state.pages.resetPassword.email,
})

export default connect(mapState)(CheckEmail)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/ResetPassword/CheckEmail.js